import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await register(email, password, name);
    setLoading(false);
    if (r.ok) {
      toast.success("Welcome to Soirée");
      nav(next || "/dashboard");
    }
    else toast.error(r.error);
  };

  return (
    <div className="min-h-screen bg-[#FBF9F4]" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">Begin</div>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif" }} className="text-5xl mt-2 font-light tracking-tight">Create your studio.</h1>
        <p className="mt-4 text-sm text-neutral-600 leading-relaxed">
          Accounts are free. You&apos;ll need a redemption code from Etsy to publish your first invite — building and previewing is always free.
        </p>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <Label className="text-[10px] tracking-[0.25em] uppercase">Your name</Label>
            <Input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} className="rounded-sm mt-1" />
          </div>
          <div>
            <Label className="text-[10px] tracking-[0.25em] uppercase">Email</Label>
            <Input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-sm mt-1" />
          </div>
          <div>
            <Label className="text-[10px] tracking-[0.25em] uppercase">Password</Label>
            <Input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-sm mt-1" />
          </div>
          <Button type="submit" disabled={loading} data-testid="register-submit" className="w-full rounded-sm bg-neutral-900 hover:bg-neutral-800 h-11 tracking-[0.2em] uppercase text-xs">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-neutral-600">
          Already a host? <Link to="/login" className="underline underline-offset-4">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
